export default "__VITE_ASSET__BDZT5dWZ__"